import { IContactBase } from './contact-base.interface';

export type ICustomer = IContactBase;
